<div [class.active]="loading()" class="splash-screen">
    <div class="splash-container">
        <div class="load-bar">
            <div class="bar"></div>
            <div class="bar"></div>
        </div>
    </div>
</div>
